module.exports = __webpack_public_path__ + "img/symbol_3.96a18b7b.png";